import { X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ContextChipProps extends Omit<React.ComponentProps<'span'>, 'children'> {
  label: string
  onRemove: () => void
}

/** What the next message is about: a label with a remove button (44px tap target). */
function ContextChip({ label, onRemove, className, ...props }: ContextChipProps) {
  return (
    <span
      data-slot="context-chip"
      className={cn(
        'bg-secondary text-secondary-foreground inline-flex max-w-full items-center gap-1 rounded-full pl-3 text-sm',
        className
      )}
      {...props}
    >
      <span className="min-w-0 truncate">{label}</span>
      <button
        type="button"
        onClick={onRemove}
        aria-label={`Remove ${label}`}
        className="tap-target hover:bg-muted flex size-8 shrink-0 items-center justify-center rounded-full"
      >
        <X className="size-4" />
      </button>
    </span>
  )
}

export { ContextChip }
